import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

type BrandMarkProps = {
  // when set, the mark is a link; omit it to render a non-interactive mark
  to?: string
  size?: 'sm' | 'lg'
  className?: string
}

const sizes = {
  sm: { tile: 'w-8 h-8', glyph: 'text-sm', word: 'text-lg font-semibold' },
  lg: { tile: 'w-10 h-10', glyph: 'text-base', word: 'text-2xl font-bold' },
}

export function BrandMark({ to, size = 'sm', className }: BrandMarkProps) {
  const s = sizes[size]
  const wrapperClass = cn('flex items-center gap-2', className)
  const content = (
    <>
      <div className={cn(s.tile, 'bg-gradient-to-r from-primary to-accent rounded-lg flex items-center justify-center')}>
        <span className={cn('text-primary-foreground font-bold', s.glyph)}>B</span>
      </div>
      <span className={cn('text-foreground', s.word)}>Bookmi</span>
    </>
  )

  return to ? (
    <Link to={to} className={wrapperClass}>
      {content}
    </Link>
  ) : (
    <div className={wrapperClass}>{content}</div>
  )
}
